module.exports = __webpack_public_path__ + "static/completeNL-d7df4307fb36b4b4d226218dd5844792.png";